import moment from 'jalali-moment';
import momentTZ from 'moment-timezone';
import momentHJ from 'moment-hijri';

type InputType = moment.Moment | moment.Moment[];

export const TIMEZONE = momentTZ.tz.names().filter(zone => {
  if (zone.indexOf('/') === -1 || zone.indexOf('Etc/') !== -1) {
    return false;
  }
  return true;
});

export function applyTimezone(date: moment.Moment[], timezone: string): moment.Moment[];
export function applyTimezone(date: moment.Moment, timezone: string): moment.Moment;
export function applyTimezone(date: InputType, timezone: string): InputType {
  if (!Array.isArray(date)) {
    const tzResult = momentTZ(date.toDate()).tz(timezone);
    return moment(tzResult as any).locale(date.locale());
  }
  const result = [];
  for (const item of date) {
    const tzResult = momentTZ(item.toDate()).tz(timezone);
    result.push(moment(tzResult as any).locale(item.locale()));
  }
  return result;
}

export function getOffsetByTimezone(date: Date | moment.MomentInput, zone: string) {
  return momentTZ(date as any).tz(zone).utcOffset();
}

export function format(date: any, format: string, calendar: 'fa' | 'en' | 'ar') {
  if (calendar === 'ar') {
    return momentHJ(date as any).locale('ar-SA').format(format);
  }
  return moment(date as any).locale(calendar).format(format);
}

export function getCalendarTextByLetter(letter: string = '') {
  switch (letter.toUpperCase()) {
    case 'J':
      return 'جلالی (شمسی)';
    case 'G':
      return 'میلادی';
    case 'H':
      return 'هجری قمری';
    default:
      return 'نامشخص';
  }
}

export function getSupportedTimezone() {
  return TIMEZONE;
}

const timeUtils = {
  TIMEZONE,
  applyTimezone,
  getOffsetByTimezone,
  getCalendarTextByLetter,
  getSupportedTimezone,
  format,
};

export default timeUtils;
